<!--
 * @Description: ================== 游戏介绍 =================
 * @Date: 2022-05-13 18:08:07
 * @Author: Zero
 * @FilePath: \guobao-web\src\components\Game.vue
 * @LastEditors: Zero
 * @LastEditTime: 2022-06-14 14:51:49
-->
<template>
  <div class="page page-game">
    <div style="margin-top:20px">
      <img src="/banner.jpg" alt="" style="width: 100%" />
    </div>
    <h2 class="title">游戏介绍</h2>
    <p>《碎梦者》是一款咒术 IP 改编二次元卡牌手游，延续原作暗黑咒力世界观，构筑人与咒灵共生的现代都市领域。集结高专特级术师，融合卡牌收集、术式策略布阵与角色深度养成玩法，搭配专属角色羁绊，深入结界祓除凶恶咒灵，开启守护人间的咒术冒险征程！</p>
    <!-- <pre> -->
    <div class="content">
      <div class="content-item">
        <h4>【原作都市实景复刻，暗黑咒术氛围感拉满】</h4>
          1:1 还原动画经典地铁、高专校舍、涉谷街道等标志性场景，冷调写实画风还原诡秘咒灵世界。主界面搭载招募、竞技、学院、主线祓除多元功能，千抽福利、七日狂欢、限时赠礼、战令活动持续上新，沉浸式踏入危机四伏的咒术世界！
        <img src="/1.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【全系列术师卡牌收录，专属领域招式极致还原】</h4>
          精细二次元立绘打磨每位角色细节，五条悟、虎杖悠仁、伏黑甚尔、两面宿傩等全篇章人气角色全员登场。完美复刻无量空处、十种影法术、黑闪等招牌术式动画，角色神态、服饰、标志性特征高度贴合原作，满足全术师收集养成爱好者！
        <img src="/2.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【羁绊策略布阵对战，多元咒术打法自由搭配】</h4>
          术师分为强攻、控场、续航、结界多重定位，每名角色拥有独一无二专属领域奥义。同篇章术师上阵激活强力羁绊联动增伤，自由调整站位搭配战术；推进主线祓除快速解锁全部系统，依靠术式克制智取各类特级咒灵与竞技对手。
        <img src="/3.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【超多特色咒术副本，多人竞技热血开战】</h4>
          开放涉谷事变、京都夜巡、咒灵大冒险、试炼秘境特色副本，更有冠军赛竞技、多人联合祓灵、跨服擂台对抗玩法。本源招募、限时礼包、累积豪礼常驻开放，钻石、术师碎片、养成资源轻松领取。
        <img src="/4.jpg" alt="" />
      </div>
    </div>
    <!-- </pre> -->
  </div>
</template>

<style scss>
.content-item {
  display: inline-block;
  width: 50%;
  padding: 12px;
  box-sizing: border-box;
  vertical-align: top;
}
.content-item img {
  display: block;
  margin-top: 12px;
  width: 400px;
}
@media screen and (max-width: 768px) {
  .content-item {
    width: 100%;
  }
  .content-item img {
    width: 100%;
  }
}
</style>
